import { point3d, Units, DxfWriter } from "@tarikjabiri/dxf";
import { add2dShapes, drawShapeToBlock } from "./DxfDraw";
import { calculateBlockDimensions } from "./DxfCalculations";

// Main DXF generation function
export const generateDxf = (dxfData, projectName) => {
    const dxf = new DxfWriter();
    dxf.setUnits(Units.Unitless); // Set DXF units (can be updated later)

    // Create reusable blocks for 3D scene and 2D row layout
    const sceneBlock = dxf.addBlock(`ThreeScene`);
    const rowBlock = dxf.addBlock(`RowBlock`);

    let polygonPlacementX = 0; // Horizontal placement for next 2D shape
    let lastMax = 0; // Track previous polygon's width for spacing

    // Draw all 3D model shapes into the scene block
    dxfData.forEach((item) => {
        // Draw main polygon with label
        drawShapeToBlock(dxf, item.polygon, sceneBlock, { addName: true }, item.label);

        // Draw setback shapes
        let setbackShape = [];
        item.setbacks.forEach((sb) => {
            setbackShape.push(sb.vertex);
        });
        if (setbackShape.length > 0) {
            drawShapeToBlock(dxf, setbackShape, sceneBlock, {});
        };

        // Draw obstructions
        item.obstruction.forEach((obs, obsIndex) => {
            drawShapeToBlock(dxf, obs.polygon, sceneBlock, {}, obsIndex);
        });

        // Draw panels
        item.panels.forEach((panel, panIndex) => {
            drawShapeToBlock(dxf, panel.polygon, sceneBlock, {}, panIndex);
        });
    });

    // Draw 2D layout version of each polygon
    dxfData.forEach((item, index) => {
        const polygonBlock = dxf.addBlock(`PolygonBlock_${index}`);
        const polyData = add2dShapes(dxf, item, polygonBlock, index); // Draw 2D shapes and return bounds

        // Position this polygon to the right of the last one
        polygonPlacementX = index !== 0
            ? polygonPlacementX + (20 * 12) + lastMax + (-polyData.minX)
            : polygonPlacementX;

        // Insert this 2D block into the row block
        rowBlock.addInsert(polygonBlock.name, point3d(polygonPlacementX, 0, 0));

        lastMax = polyData.maxX; // Update for next placement
    });

    // Position 3D scene and 2D row in the final drawing
    const sceneDimensions = calculateBlockDimensions(sceneBlock); // Get scene dimensions
    const rowBlockPlacementY = sceneDimensions.minY - 200; // Place row below the scene

    dxf.addInsert(sceneBlock.name, point3d(0, 0, 0)); // Add 3D scene to drawing
    dxf.addInsert(rowBlock.name, point3d(sceneDimensions.minX, rowBlockPlacementY, 0)); // Add 2D row

    // Output the final DXF to download
    print(dxf, projectName);
};

// Utility function to generate and trigger DXF file download
function print(dxfInstance, projectName) {
    // Override header for units and precision settings
    let $units = '$DIMALTU\n  70\n6\n  9\n';
    $units += '$DIMLUNIT\n  70\n4\n  9\n';
    $units += '$LUNITS\n  70\n4\n  9\n$ACADVER';

    let dxf_output = dxfInstance.stringify(); // Get DXF string
    dxf_output = dxf_output.replace('$ACADVER', $units); // Insert custom header

    // Trigger browser download
    const element = document.createElement('a');
    let dxf_file = new Blob([dxf_output], { type: 'text/plain' });

    element.href = URL.createObjectURL(dxf_file);
    element.download = projectName + '.dxf';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}
